import {
  Titles,
  Position
} from '../../../constants';
import { FieldTypes } from '../../../components/FormBuilder';

const IdTypes = [
  {
    'label': 'South African ID',
    'value': 'id'
  },
  {
    'label': 'SA Passport',
    'value': 'sapp'
  },
  {
    'label': 'Non-SA Passport',
    'value': 'pp'
  }
];

export const positionInCompany = {
  placeholder: 'Position in company',
  name: 'positionInCompany',
  options: Position,
  scrollToTop: false
};

export const identityType = {
  placeholder: 'Identity Type',
  name: 'idType',
  options: IdTypes,
  scrollToTop: false
};

export const idNumber = {
  type: 'text',
  inputMode: 'text',
  name: 'idNumber',
  placeholder: 'ID number',
  disabled: false,
  dark: false,
  hideUnderline: true
};

export const idNumberFields = {
  false: [],
  true: [
    {
      type: FieldTypes.CUSTOM_SELECT,
      props: {
        placeholder: 'Title',
        name: 'title',
        options: Titles,
        scrollToTop: false
      }
    },
    {
      type: FieldTypes.INPUT,
      props: {
        placeholder: 'Name',
        name: 'firstName',
        type: 'text',
        inputMode: 'text',
        disabled: false,
        dark: false,
        hideUnderline: true
      }
    },
    {
      type: FieldTypes.INPUT,
      props: {
        placeholder: 'Surname',
        name: 'surName',
        type: 'text',
        inputMode: 'text',
        disabled: false,
        dark: false,
        hideUnderline: true
      }
    },
    {
      type: FieldTypes.INPUT,
      props: {
        placeholder: 'Email address',
        name: 'email',
        type: 'text',
        inputMode: 'text',
        disabled: false,
        dark: false,
        hideUnderline: true
      }
    },
    {
      type: FieldTypes.INPUT,
      props: {
        placeholder: 'Cellphone number',
        name: 'msisdn',
        type: 'text',
        inputMode: 'text',
        disabled: false,
        dark: false,
        hideUnderline: true
      }
    }
  ]
};

export const formFields = [
  {
    type: FieldTypes.CUSTOM_SELECT,
    props: positionInCompany
  },
  {
    type: FieldTypes.CUSTOM_SELECT,
    props: identityType
  },
  {
    type: FieldTypes.INPUT,
    props: idNumber
  },
  {
    type: FieldTypes.DYNAMIC_DIRECTOR_FIELDS,
    fields: idNumberFields
  }
];
